import { memo } from 'react';
import { EditorContent } from '@tiptap/react';

function RichTextEditorContent({ editor, disabled = false }) {
  return (
  <div
    className={[
      // min-w-0: in flex layouts the child can shrink so overflow-x works for wide tables
      'bg-surface min-w-0 w-full max-w-full overflow-x-auto scrollbar-aimsos-auto',
      disabled ? 'opacity-70' : '',
    ]
      .filter(Boolean)
      .join(' ')}
  >
    <EditorContent
      editor={editor}
      className={[
        '[&_.ProseMirror]:min-h-[220px]',
        '[&_.ProseMirror]:px-4',
        '[&_.ProseMirror]:py-3',
        '[&_.ProseMirror]:text-content',
        '[&_.ProseMirror]:leading-[1.55]',
        '[&_.ProseMirror]:outline-none',
        '[&_.ProseMirror_h1]:my-2',
        '[&_.ProseMirror_h1]:text-2xl',
        '[&_.ProseMirror_h1]:font-bold',
        '[&_.ProseMirror_h1]:leading-tight',
        '[&_.ProseMirror_h1]:text-content',
        '[&_.ProseMirror_h2]:my-2',
        '[&_.ProseMirror_h2]:text-xl',
        '[&_.ProseMirror_h2]:font-semibold',
        '[&_.ProseMirror_h2]:leading-snug',
        '[&_.ProseMirror_h2]:text-content',
        '[&_.ProseMirror_p]:my-1.5',
        '[&_.ProseMirror_ul]:my-2',
        '[&_.ProseMirror_ul]:list-disc',
        '[&_.ProseMirror_ul]:pl-6',
        '[&_.ProseMirror_ol]:my-2',
        '[&_.ProseMirror_ol]:list-decimal',
        '[&_.ProseMirror_ol]:pl-6',
        '[&_.ProseMirror_li]:my-0.5',
        '[&_.ProseMirror_li]:marker:text-content-muted',
        '[&_.ProseMirror_blockquote]:my-2',
        '[&_.ProseMirror_blockquote]:border-l-4',
        '[&_.ProseMirror_blockquote]:border-edge-strong',
        '[&_.ProseMirror_blockquote]:bg-surface-muted',
        '[&_.ProseMirror_blockquote]:px-3',
        '[&_.ProseMirror_blockquote]:py-1',
        '[&_.ProseMirror_blockquote]:text-content-secondary',
        '[&_.ProseMirror_code]:rounded-md',
        '[&_.ProseMirror_code]:border',
        '[&_.ProseMirror_code]:border-edge',
        '[&_.ProseMirror_code]:bg-surface-muted',
        '[&_.ProseMirror_code]:px-1',
        '[&_.ProseMirror_code]:py-0.5',
        '[&_.ProseMirror_code]:font-mono',
        '[&_.ProseMirror_code]:text-[0.9em]',
        '[&_.ProseMirror_a]:text-brand-500 dark:[&_.ProseMirror_a]:text-brand-400',
        '[&_.ProseMirror_a]:underline',
        '[&_.ProseMirror_strong]:text-content',
        '[&_.ProseMirror_b]:text-content',
        '[&_.ProseMirror_hr]:my-4 [&_.ProseMirror_hr]:border-edge [&_.ProseMirror_hr]:border-t',
        '[&_.ProseMirror_table]:my-3 [&_.ProseMirror_table]:block [&_.ProseMirror_table]:w-max [&_.ProseMirror_table]:min-w-full [&_.ProseMirror_table]:max-w-none',
        '[&_.ProseMirror_td]:align-top [&_.ProseMirror_th]:align-top',
        '[&_.ProseMirror_p.is-editor-empty:first-child::before]:pointer-events-none',
        '[&_.ProseMirror_p.is-editor-empty:first-child::before]:float-left',
        '[&_.ProseMirror_p.is-editor-empty:first-child::before]:h-0',
        '[&_.ProseMirror_p.is-editor-empty:first-child::before]:text-content-faint',
        '[&_.ProseMirror_p.is-editor-empty:first-child::before]:content-[attr(data-placeholder)]',
      ].join(' ')}
    />
  </div>
  );
}

export default memo(RichTextEditorContent);
